export default "__VITE_ASSET__D198eg7i__"